export class ReceptorFilter {
   rutReceptorDv: number;
   razonSocial: string;
   giro: string;
   emisorId: string;
   activo: boolean;
}
